import { render, staticRenderFns } from "./listeClientInferieur.vue?vue&type=template&id=ebad7d04&scoped=true"
import script from "./listeClientInferieur.vue?vue&type=script&lang=js"
export * from "./listeClientInferieur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebad7d04",
  null
  
)

export default component.exports